// extracted by mini-css-extract-plugin
export default {"limitsExceeded":"contacts-bar_limitsExceeded__M2TMX","bar":"contacts-bar_bar__LCj3g","filled":"contacts-bar_filled__RZ35L","labels":"contacts-bar_labels__qoid2"};